var map = {
	"./Illustration-Error.svg": 395,
	"./Illustration-Transcribing.svg": 396,
	"./addhero.16.svg": 397,
	"./fonts/Bahnschrift.woff": 398,
	"./icon-16.png": 399,
	"./icon-32.png": 400,
	"./icon-80.png": 401,
	"./logo-filled.png": 402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;